// Recover-Page. Pre-Auth. POST /auth/recover (immer 200 ok, kein User-Enum-Leak).

import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Mail, KeyRound } from 'lucide-react';
import { useAuth } from '@/hooks/use-auth';

export function RecoverPage() {
  const { resetPassword, error, setError } = useAuth();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) {
      setError('Bitte E-Mail eingeben.');
      return;
    }
    setSubmitting(true);
    try {
      await resetPassword(email);
      setSent(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="relative grid min-h-dvh place-items-center px-4">
      <div className="aurora">
        <div className="aurora__blob aurora__blob--1"></div>
        <div className="aurora__blob aurora__blob--2"></div>
        <div className="aurora__blob aurora__blob--3"></div>
      </div>
      <div className="aurora-grid"></div>
      <div className="aurora-vignette"></div>

      <form
        onSubmit={handleSubmit}
        className="glass-strong relative z-10 w-full max-w-sm rounded-2xl p-6 text-neutral-100"
      >
        <div className="mb-5 flex flex-col items-center text-center">
          <div className="mb-3 grid size-12 place-items-center rounded-full bg-amber-500/15 text-amber-300">
            <KeyRound className="size-5" />
          </div>
          <h1 className="text-xl font-semibold">Passwort zurücksetzen</h1>
          <p className="mt-1 text-sm text-neutral-400">
            Wir schicken dir einen Reset-Link an deine E-Mail.
          </p>
        </div>

        {sent ? (
          <div className="rounded-lg border border-emerald-500/30 bg-emerald-500/10 p-4 text-sm text-emerald-200">
            Wenn diese E-Mail bei uns existiert, hast du gleich eine Nachricht im Posteingang.
          </div>
        ) : (
          <>
            <label className="mb-4 block text-sm">
              <span className="mb-1 block text-xs uppercase tracking-wider text-neutral-500">
                E-Mail
              </span>
              <span className="glass flex items-center gap-2 rounded-lg px-3 py-2">
                <Mail className="size-4 text-neutral-500" />
                <input
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 bg-transparent text-sm text-neutral-100 outline-none placeholder:text-neutral-500"
                  placeholder="doc@upro.de"
                />
              </span>
            </label>

            {error ? (
              <p className="mb-3 rounded-md border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-xs text-rose-300">
                {error}
              </p>
            ) : null}

            <button
              type="submit"
              disabled={submitting}
              className="w-full rounded-lg bg-amber-500 px-4 py-2 text-sm font-medium text-neutral-950 shadow-[0_0_20px_rgba(251,191,36,0.3)] transition hover:bg-amber-400 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {submitting ? 'Sende…' : 'Reset-Link anfordern'}
            </button>
          </>
        )}

        <div className="mt-4 text-center text-xs text-neutral-400">
          <Link to="/login" className="hover:text-amber-300 hover:underline">
            ← Zurück zum Login
          </Link>
        </div>
      </form>
    </main>
  );
}
